import type { SaveData } from '../domain/save.js';
import { validateSave } from '../domain/save.js';
export const TEST_TOOLS = import.meta.env.DEV || import.meta.env.VITE_ENABLE_TEST_TOOLS === 'true';
const files = TEST_TOOLS ? import.meta.glob<SaveData>('../../test/fixtures/saves/*.json',{eager:true,import:'default'}) : {};
export const checkpoints = Object.keys(files).map(path=>path.split('/').pop()!.slice(0,-5)).sort();
export function checkpoint(id: string | null): SaveData | undefined {
    if (!id) return undefined;
    if (!TEST_TOOLS) throw new Error('Career checkpoints are available only in development or an authorized test build.');
    const path = Object.keys(files).find(path=>path.endsWith('/'+id+'.json'));
    if (!path) throw new Error('Unknown career checkpoint: '+id);
    const save = validateSave(files[path]);
    if (!save) throw new Error('Career checkpoint is invalid or stale: '+id);
    return save;
}
